import React, { Component } from 'react';
import './DrugHistoryCard.css';
import Card from '../../components/card/Card';
import mainAPI from '../../api/MainAPI';
import HeaderRow from '../../components/headerRow/HeaderRow';
import Row from '../../components/row/Row';
import Label from '../../components/label/Label';
import utils from '../../utils/utils';
import Volume from '../../components/volume/Volume';
import CardHeader from '../../components/cardHeader/CardHeader';

export default class DrugHistoryCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			stock_move_records: []
		};
	}

	async componentDidMount() {
		await this.getData(this.props.drugId);
	}

	async componentWillReceiveProps(nextProps) {
		if (this.state.stock_move_records.length === 0) {
			await this.getData(nextProps.drugId);
		}
	}

	async getData(drugId) {
		if (!drugId) return;
		const stock_move_records = await mainAPI.stock_move_record.forDrug(drugId);
		this.setState({ stock_move_records });
	}

	renderTable = () => {
		let columns = [
			{ label: 'User' },
			{ label: 'Record Type' },
			{ label: 'Witness' },
			{ label: 'Guest Witness' },
			{ label: 'Created At' },
			{ label: 'Dosage' }
		];
		let display = [<HeaderRow key={'header'} columns={columns} />];
		for (let i in this.state.stock_move_records) {
			const record = this.state.stock_move_records[i];
			display.push(
				<Row key={record.id}>
					<Label> {record.user_name}</Label>
					<Label capitalize> {(record.stock_move_type__display_name || '').replace(/_/g, ' ')}</Label>
					{/*<Label> {record.incident_number}</Label>*/}
					<Label> {record.witness_name}</Label>
					<Label> {record.guest_verify_name}</Label>
					<Label> {utils.display_actual_datetime(record.created_on)}</Label>
					<Label>
						{' '}
						<Volume value={record.quantity} type={this.props.type} />
					</Label>
				</Row>
			);
		}
		return display;
	};

	render() {
		return (
			<Card className="g-drug-history-card">
				<CardHeader>Drug History</CardHeader>
				{this.renderTable()}
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/cards/drugHistoryCard/DrugHistoryCard.jsx